import Head from "next/head"

import Another from "../../components/another-component"
import Button from "../../components/button"
import data from "../../components/data"
import { PythonPrerequisite } from "../../components/info"
import {
  courseDataToSchema,
  schemaElementFromSchema,
} from "../../components/utils"

const Course = () => {
  const courseId = "p-wd-fs"
  const schema = courseDataToSchema(data, courseId)
  const courseInstances = schema.courseInstances
  const schemaElement = schemaElementFromSchema(schema)
  return (
    <div>
      <Head>
        <title>
          Tinklalapių kūrimas (fullstack) su Python ir React | Pirmas kodas
        </title>
        <meta
          name="description"
          content="Tinklalapių kūrimo (fullstack) su Python ir React kursas. Jo metu išmoksite pilnai sukurti tinklalapį suderindami Python backend framework'us su React frontend'u."
        />
      </Head>
      {schemaElement}

      <article className="prose dark:prose-invert">
        <div>
          <h1>Tinklalapių kūrimas (fullstack) su Python ir React</h1>
          <div>
            <h3>Tikslinė auditorija</h3>
            <p>
              Šiame kurse išmoksite padaryti tinklalapį nuo iki. Mokysimės
              dviejų populiariausių kalbų. Python - populiariausia kalba
              pasaulyje. O React - populariausias frontend frameworkas.
            </p>
          </div>
          <PythonPrerequisite />
          <div>
            <h3>Temos</h3>
            <ul>
              <li>RESTful API</li>
              <li>Flask</li>
              <li>Django</li>
              <li>FastAPI</li>
              <li>Databases</li>
              <li>ORM</li>
              <li>HTML</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>React</li>
              <li>Tailwind</li>
              <li>MaterialUI</li>
              <li>Baigiamasis darbas</li>
            </ul>
          </div>
        </div>
        {courseInstances ? (
          <>
            <h2>Artimiausios grupės</h2>
            {courseInstances.map((instance) => {
              return Another(instance, data.links.generalRegistrationForm)
            })}
          </>
        ) : (
          <Button href={data.links.generalRegistrationForm} />
        )}
      </article>
    </div>
  )
}

export default Course
